import { useEffect, useState } from 'react';

export default function useDesktopWindowFocusSignal() {
  const [desktopFocusSignal, setDesktopFocusSignal] = useState(0);

  useEffect(function refreshOnDesktopWindowFocus() {
    if (!window.electron) return undefined;

    function handleWindowFocus() {
      setDesktopFocusSignal((signal) => signal + 1);
    }

    window.addEventListener('focus', handleWindowFocus);
    window.addEventListener('output:desktop-oauth-complete', handleWindowFocus);
    return function removeDesktopRefreshListeners() {
      window.removeEventListener('focus', handleWindowFocus);
      window.removeEventListener('output:desktop-oauth-complete', handleWindowFocus);
    };
  }, []);

  return desktopFocusSignal;
}
